format_ele_str = (element) => {
    element = element.startsWith('#') ? element : '#' + element;
    return element;
}

// A radio or checkbox never changes its value attribute — its state lives on
// `checked` — so a val() comparison can never see it dirty (DEV-12519 QA r2:
// radio changes didn't enable Save). One reader for every state site below.
input_state_value = ($el) => {
    const type = ($el.attr('type') || '').toLowerCase();
    if (type === 'radio' || type === 'checkbox')
        return $el.prop('checked') ? '1' : '0';
    return $el.val();
}

set_input_state = (string, observe=false, selectors='input, select, textarea') => {
    var inputs = am.$(`#${string}`).find(selectors).not('.js-omit-prev_state');
    inputs.each((i, el) => {
        const $el = am.$(el);
        $el.attr('data-prev_state', input_state_value($el));
    })
    if(observe)
        observe_form_changes(string, selectors);
}

clear_all_prev_state = (string) => {
    var inputs = am.$(`#${string}`).find('[data-prev_state]').not('.js-omit-prev_state');
    inputs.each((i, el) => {
        const $el = am.$(el);
        $el.off('change');
        $el.removeAttr('data-prev_state');
    })
}

observe_form_changes = (string, selectors='input, select, textarea') => {
    var inputs = am.$(`#${string}`).find(selectors);
    inputs.each((i, el) => {
        const $el = am.$(el);
        $el.on('change', () => {
            update_dirty_input($el, string, selectors)
        })
    });
}

update_dirty_input = ($el, string, selectors='input, select, textarea') => {
    if($el.hasClass('js-omit-prev_state') && $el.attr('data-target_id'))
        $el = am.$(`#${$el.attr('data-target_id')}`)

    if($el.attr('data-prev_state') == input_state_value($el))
        $el.removeClass('isDirty');
    else
        $el.addClass('isDirty');

    check_dirty_inputs(string, selectors);
}

check_dirty_inputs = (string, selectors='input, select, textarea') => {
    $form = am.$(format_ele_str(string));
    var inputs = $form.find(selectors).not('.js-omit-prev_state');

    var dirty_list = [];
    inputs.each((i, el) => {
        const $el = am.$(el);
        if($el.hasClass('is_ckeditor')){
            if($el.hasClass('is_dirty'))
                dirty_list.push($el)
        }else{
            if(input_state_value($el) != $el.attr('data-prev_state'))
                dirty_list.push($el);
        }
    })

    let disabled = true;
    if(dirty_list.length > 0){
        bind_is_dirty_e($form);
        disabled = false;
    }
    else{
        unbind_is_dirty_e($form);
    }

    const $btn = am.$('#'+$form.attr('data-form-submit-button'));
    const includeDisabledClass = $form.attr('data-form-submit-button-disabled');

    if($btn.length > 0)
        toggle_form_submit_btn($btn, disabled, includeDisabledClass);
}

form_is_dirty = (element, form=false) => {
    var $form = false;
    if (form && typeof form === 'string') {
        form = format_ele_str(form);
        $form = am.$(form);
    }else{
        if (typeof element === 'string') 
            element = format_ele_str(element);
    
        const $element = am.$(element);
        $form = $element.closest('form.watchform');
    
        if ($element.is('form')) 
            $form = $element;
    }

    if ($form.length > 0)
        bind_is_dirty_e($form);
}

unbind_is_dirty_e = (form) => {
    var $form;
    if (form && typeof form === 'string') {
        form = format_ele_str(form);
        $form = am.$(form);
    }else{
        $form = form;
    }

    if($form.length > 0)
        $form.removeClass('is_dirty_form');
    beforeUnloadHandler();
}

bind_is_dirty_e = ($form) => {
    $form.addClass('is_dirty_form');
    beforeUnloadHandler(true);
}

beforeUnloadHandler = (add=false) => {
    window.onbeforeunload = () => { };
    if(add){
        window.onbeforeunload = () => { 
            return "You may have unsaved data that will be lost and cannot be recovered."; 
        }
    }
}

function redirect_location(defined_redirection=false){
    if(!defined_redirection)
        location.reload();
    else
        window.location.href = defined_redirection
};

set_form_watch = (element, find="input, select", event='change') => {
    if (typeof element === 'string') 
        element = format_ele_str(element);

    var inputs = am.$(element).find(find);

    inputs.each((i, el) => {
        const $el = am.$(el);
        if(event == 'input'){
            $el.on('input', () => {
                form_is_dirty(el, element);
                check_dirty_inputs(element.replace('#', ''), find);
            })
        }else{
            $el.on(event, () => {
                form_is_dirty(el, element);
            })
        }
    })
}

watch_inputs = (arr, $err_elm) => {
    const type = arr[0];
    const ev_listener = arr[1];
    arr.each((item, i) => {
        if(i < 2)
            return;

        if(typeof item == 'string')
            item = am.$(`#${item}`);
        
        item.on(ev_listener, () => {
            if(type == 'checkbox'){
                if(item.prop('checked') && $err_elm.length > 0)
                    $err_elm.remove();
            }
        })
    })
}

check_dirty_ckeditor = (e, formString) => {
    const editor = e.editor;
    const $textarea = am.$(editor.element.$);
    $textarea.addClass('is_ckeditor')

    if($textarea.val().trim() != editor.getData().trim())
        $textarea.addClass('is_dirty');
    else
        $textarea.removeClass('is_dirty');

    check_dirty_inputs(formString);
}

toggle_form_submit_btn = ($btn, disabled, skipDisabledProp ) => {
    if(!Number(skipDisabledProp)){
        $btn.prop('disabled', disabled);
    }
    if($btn.hasClass('am-btn--outlined')){
        disabled ? $btn.addClass('am-btn--disabled') : $btn.removeClass('am-btn--disabled');
    }
}

force_refresh = () => {
    location.reload();
    $form.addClass('is_dirty_form');
};